<ng-container>
  <div class="modal-header">
    @if (isEdit) {
      <h4
        class="modal-title"
        style="margin: 0 auto"
        id="createOrderModalLabel">
        Edit Order
      </h4>
    }
    @if (!isEdit) {
      <h4
        class="modal-title"
        style="margin: 0 auto"
        id="createOrderModalLabel">
        Create Order
      </h4>
    }
  </div>
  <div class="modal-body" data-cy="createOrderModalBody">
    @if ((clients$ | async) && (clients$ | async)?.length > 0) {
      <form [formGroup]="orderForm" class="clrsgn-form">
        <p>*Required Information</p>
        <span class="modal-grp-heading">Order Info</span>
        <div class="row marginTopTenPx">
          <div class="col-6">
            <mat-form-field appearance="fill" class="clrsgn-form-field">
              <mat-label class="clrsgn-label">Organization</mat-label>
              <mat-select data-cy="organizationDropdownList"
                placeholder="--Select An Organization--"
                [selectOnTab]="true"
                id="clientId"
                formControlName="clientId">
                <input matInput placeholder="Filter" class="clrsgn-form-field mat-option" formControlName="clientFilter1" (input)="performClientFilter()" #clientInput>
                <hr />
                @for (client of filteredClients; track client) {
                  <mat-option
                    [value]="client.clientId">
                    {{ client.clientName }}
                  </mat-option>
                }
              </mat-select>
              <app-form-error [group]="orderForm"
              [controlName]="'clientId'"></app-form-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="fill" class="clrsgn-form-field">
              <mat-label for="scheduledDate" class="clrsgn-label">
                Scheduled Date
              </mat-label>
              <input matInput
                [matDatepicker]="scheduledDatepicker"
                [min]="minDate"
                formControlName="scheduledDate"
                id="scheduledDate"
                [formGroup]="orderForm" />
                <mat-datepicker-toggle matSuffix [for]="scheduledDatepicker">
                  <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #scheduledDatepicker></mat-datepicker>
                <app-form-error [group]="orderForm"
                [controlName]="'scheduledDate'"></app-form-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row marginTopTwentyPx">
            <div class="col-6">
              <mat-form-field appearance="fill" class="clrsgn-form-field">
                <mat-label for="closingType" class="clrsgn-label">Signing Type</mat-label>
                <mat-select data-cy="signingTypeDropdownList"
                  placeholder="--Select A Signing Type--"
                  [selectOnTab]="true"
                  id="closingType"
                  formControlName="closingType">
                  @for (closingType of closingTypes; track closingType) {
                    <mat-option
                      [value]="closingType.key">
                      {{ closingType.value }}
                    </mat-option>
                  }
                </mat-select>
                <app-form-error [group]="orderForm"
                [controlName]="'closingType'"></app-form-error>
              </mat-form-field>
            </div>
            <div class="col-6">
              <mat-form-field appearance="fill" class="clrsgn-form-field">
                <mat-label class="clrsgn-label">
                  Scheduled Time <mat-icon class="tooltip-icon" style="height: 1.1rem; width: 1.2rem;" matTooltip="Enter time in the property address' time zone." matTooltipPosition="above" matTooltipShowDelay="500" svgIcon="information"></mat-icon>
                </mat-label>
                <input matInput
                  id="scheduledTime"
                  readonly
                  formControlName="scheduledTime"
                  [matTimepicker]="scheduledTimeTimepicker"
                  (click)="scheduledTimeTimepicker.open()" />
                  <mat-timepicker-toggle matSuffix [for]="scheduledTimeTimepicker"></mat-timepicker-toggle>
                  <mat-timepicker #scheduledTimeTimepicker
                    mode="input"
                    [enableKeyboardInput]="true">
                  </mat-timepicker>
                  <app-form-error [group]="orderForm" [controlName]="'scheduledTime'"></app-form-error>
                </mat-form-field>
              </div>
            </div>
            @if ((showWarning$ | async)) {
              <div
                class="row known-signer-warning p-3 margin-top-twenty-px">
                <div class="icon-container p-3">
                  <span class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></span>
                </div>
                <div class="warning-text">Use of this Signing Type will remove the verification process for all Signers during check-in. Use only if the Notary has personal knowledge of all Signers.</div>
              </div>
            }
            <span class="modal-grp-heading mt-4">
              Transaction Information
            </span>
            <div class="row marginTopTwentyPx">
              <div class="col-12 col-md-12 col-lg-6 mb-md-2">
                <mat-form-field appearance="fill" class="clrsgn-form-field">
                  <mat-label for="loanNumber" class="clrsgn-label">Loan #</mat-label>
                  <input matInput
                    type="text"
                    maxlength="32"
                    [ngClass]="{'invalid-text-field': isFieldInvalidDirty(orderForm, 'loanNumber')}"
                    id="loanNumber"
                    formControlName="loanNumber">
                    <app-form-error [group]="orderForm"
                    [controlName]="'loanNumber'"></app-form-error>
                  </mat-form-field>
                </div>
                <div class="col-12 col-md-12 col-lg-6 ">
                  <mat-form-field appearance="fill" class="clrsgn-form-field">
                    <mat-label for="thidPartyOrderIdentifier" class="clrsgn-label">
                      3rd Party Order ID
                    </mat-label>
                    <input matInput
                      type="text"
                      maxlength="32"
                      [ngClass]="{'invalid-text-field': isFieldInvalidDirty(orderForm, 'thirdPartyOrderIdentifier')}"
                      id="thirdPartyOrderIdentifier"
                      formControlName="thirdPartyOrderIdentifier">
                      <app-form-error [group]="orderForm"
                      [controlName]="'thirdPartyOrderIdentifier'"></app-form-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row marginTopTenPx">
                  <div class="col-12 col-md-12 col-lg-6">
                    <mat-form-field appearance="fill" class="clrsgn-form-field">
                      <mat-label for="partnerOrderIdentifier" class="clrsgn-label">
                        My Order Id
                      </mat-label>
                      <input matInput
                        type="text"
                        maxlength="32"
                        id="partnerOrderIdentifier"
                        formControlName="partnerOrderIdentifier">
                        <app-form-error [group]="orderForm"
                        [controlName]="'partnerOrderIdentifier'"></app-form-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <span class="modal-grp-heading mt-4">
                    Property Information
                  </span>
                  <div class="row marginTopTenPx">
                    <div class="col">
                      <mat-form-field appearance="fill" class="clrsgn-form-field">
                        <mat-label for="address" class="clrsgn-label"> Street Address </mat-label>
                        <input matInput
                          type="text"
                          maxlength="100"
                          id="address"
                          formControlName="address">
                          <app-form-error [group]="orderForm"
                          [controlName]="'address'"></app-form-error>
                        </mat-form-field>
                      </div>
                      <div class="col">
                        <mat-form-field class="clrsgn-form-field" appearance="fill">
                          <mat-label for="address2" class="clrsgn-label">
                            Street Address 2
                          </mat-label>
                          <input matInput
                            type="text"
                            maxlength="50"
                            id="address2"
                            formControlName="address2">
                            <app-form-error [group]="orderForm"
                            [controlName]="'address2'"></app-form-error>
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="row marginTopTenPx">
                        <div class="col-12 col-md-4 col-lg-6">
                          <mat-form-field appearance="fill" class="clrsgn-form-field">
                            <mat-label for="city" class="clrsgn-label"> City </mat-label>
                            <input matInput
                              type="text"
                              maxlength="50"
                              id="city"
                              formControlName="city">
                              <app-form-error [group]="orderForm"
                              [controlName]="'city'"></app-form-error>
                            </mat-form-field>
                          </div>
                          <div class="col-12 col-md-5 col-lg-3">
                            <mat-form-field appearance="fill" class="clrsgn-form-field">
                              <mat-label for="state" class="clrsgn-label">State</mat-label>
                              <mat-select data-cy="stateDropdownList"
                                placeholder="--Select A State--"
                                [selectOnTab]="true"
                                id="state"
                                formControlName="state">
                                @for (state of states; track state) {
                                  <mat-option data-cy="stateOptions"
                                    [value]="state.code">
                                    {{ state.name }}
                                  </mat-option>
                                }
                              </mat-select>
                              <app-form-error [group]="orderForm"
                              [controlName]="'state'"></app-form-error>
                            </mat-form-field>
                          </div>
                          <div class="col-12 col-md-3 col-lg-3">
                            <mat-form-field appearance="fill" class="clrsgn-form-field">
                              <mat-label for="zip" class="clrsgn-label"> Zip </mat-label>
                              <input matInput
                                onlyNumbers
                                type="text"
                                maxlength="5"
                                id="zip"
                                formControlName="zip">
                                <app-form-error [group]="orderForm"
                                [controlName]="'zip'"></app-form-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </form>
                      } @else {
                        <div class="jumbotron empty-jumbotron-message">
                          <div class="d-flex justify-content-center align-items-center">
                            <span class="jumbotron-heading"></span>
                            <span class="fas fa-spinner fa-spin primary-color-txt fa-2x ms-2"></span>
                          </div>
                        </div>
                      }
                    </div>
                    <div class="modal-footer">
                      <button type="button"
                        class="btn-secondary"
                        (click)="activeModal.close('cancel')"
                        data-cy="formCancelOrderButton">
                        Cancel
                      </button>
                      @if (!isEdit) {
                        <button
                          type="button"
                          class="btn-primary"
                          (click)="save()"
                          data-cy="formCreateOrderButton">
                          Create Order
                        </button>
                      }
                      @if (isEdit) {
                        <button
                          type="button"
                          class="btn-primary"
                          [disabled]="isEdit && (clients$ | async)?.length == 0"
                          (click)="updateOrder()"
                          data-cy="formUpdateOrderButton">
                          Update Order
                        </button>
                      }
                    </div>
                  </ng-container>
